import { EntityContact } from '@rcp/types';
import { RestSlice } from '../../redux/rest.slice';

export const entityContactsSlice = new RestSlice<EntityContact>('entityContacts', '');
export default entityContactsSlice.rests.reducer;
